import React, { useEffect, useRef, useState } from 'react'

interface RecordDetailProps {
    header: string
    details?: string | React.ReactElement | React.ReactElement[] | null
    subtitle?: string | React.ReactElement
    isText?: boolean
    children?: React.ReactNode
}

/** @deprecated */
export const RecordDetail: React.FC<RecordDetailProps> = ({
    header,
    details,
    subtitle,
    isText,
    children,
}) => {
    const [isExpanded, setExpanded] = useState(false)
    const [isExpanding, setExpanding] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (ref.current && ref.current.clientHeight > 150) {
            setExpanding(true)
        }
    }, [])

    let expandedClassName = ''
    if (isText && isExpanding) {
        expandedClassName = `text-${isExpanded ? 'expanded' : 'minimized'}`
    }

    const clickExpansion = (e: React.MouseEvent<HTMLButtonElement>, expanded: boolean) => {
        e.preventDefault()
        setExpanded(expanded)
    }

    return (
        <div className="recordDetails">
            <h2>{header}</h2>
            <div ref={ref}>
                {details && (
                    <>
                        <div className={`details ${isText ? 'text' : ''} ${expandedClassName}`}>
                            {details}
                        </div>
                        {isText && isExpanding && !isExpanded && (
                            <div className="viewExpansion">
                                <button onClick={(e) => clickExpansion(e, true)}>View more</button>
                            </div>
                        )}
                        {isText && isExpanded && (
                            <div className="viewExpansion">
                                <button onClick={(e) => clickExpansion(e, false)}>View less</button>
                            </div>
                        )}
                    </>
                )}
                {subtitle && <div className="subtitle">{subtitle}</div>}
                {children}
            </div>
        </div>
    )
}
